import { createFileRoute, Link, notFound } from "@tanstack/react-router";

import { HubPlacePage, hubPlaceQuery } from "@/components/hubs/HubPlacePage";
import { hubPlaceHead } from "@/lib/hub-seo";

export const Route = createFileRoute("/fi/cafes/$slug")({
  loader: async ({ params, context }) => {
    const data = await context.queryClient.ensureQueryData(hubPlaceQuery("cafes", params.slug));
    if (!data) throw notFound();
    return data;
  },
  head: ({ params, loaderData }) =>
    hubPlaceHead({ path: `/fi/cafes/${params.slug}`, locale: "fi", loaderData }),
  component: CafesFiPlaceRoute,
  notFoundComponent: () => (
    <div className="flex min-h-screen items-center justify-center p-8 text-center">
      <div>
        <h1 className="font-heading text-2xl">Kahvilaa ei löytynyt</h1>
        <Link to="/fi/cafes" className="mt-6 inline-block text-royal underline">
          Selaa kaikkia
        </Link>
      </div>
    </div>
  ),
});

function CafesFiPlaceRoute() {
  const { slug } = Route.useParams();
  return <HubPlacePage hubSlug="cafes" placeSlug={slug} locale="fi" />;
}
